import React from 'react';
import { AIPanelContextV3 } from 'Components/AIPanelV3/AIPanelContextV3';

const useAIPanelV3 = () => {
  const context = React.useContext(AIPanelContextV3);
  if (!context) {
    throw new Error('useAIPanelV3 must be used within AIPanelProviderV3');
  }
  return context;
};

export default useAIPanelV3;
